const SIDE_NAV = {
  MARKETPLACE: 'SideNav > Marketplace',
  HOME: 'SideNav > Home',
}

const ALLOW_PICKING_MORE_OPTION = 'Side right > Allow picking more than one option'
const ALLOW_PICKING_MORE_OPTION_NAME = 'Side right > Allow picking more than one option > Max picks > Dropdown menu'
const SELECT_MORE_OPTION = 'Side right > Allow picking more than one option > Max picks > Select max picks'

export {
  SIDE_NAV,
  ALLOW_PICKING_MORE_OPTION,
  ALLOW_PICKING_MORE_OPTION_NAME,
  SELECT_MORE_OPTION,
}
